export const VIDEO_SOURCES_PER_PAGE: number = 20;
